var PhxCheckout = (function (PhxCheckout) {
    PhxCheckout.directDebitValidationHelper = function () {

        var _validateDirectDebit = function () {
            return _validateIBAN() === "OK";
        }

        /**
         Validate the provided IBAN number.
         https://en.wikipedia.org/wiki/International_Bank_Account_Number

         Output: Validation status
         **/

        var _mod97 = function(number) {
            var modValue = 97;
            while (number.length > 9) {
                number = (parseInt(number.substring(0, 9)) % modValue).toString() + number.substring(9);
            }
            return number % modValue;
        }

        var _hideErrorById = function(arrOfIds) {
            arrOfIds.forEach(function(element) {
                document.getElementById(element).style.display = 'none';
            })
        };

        var _validateIBAN = function () {
            var ddNumberErrorId = document.getElementById('dd_number_error');

            var ddElement = document.getElementById('id_iban');

            var number = ddElement.value;

            var ddElementsToHideById = [
                'dd_iban_bad_length',
                'dd_iban_bad_chars',
                'dd_iban_checksum_fail',
                'dd_iban_empty'
            ];
            _hideErrorById(ddElementsToHideById);

            if (number) {
                //remove spaces
                number = number.replace(/\s/g, "");
                //remove dashes
                number = number.replace(/-/g, "");

                var errorId = '';

                //Length varies per country. Doesn't exceed 34. Germany is 22
                if (number.length < 5 && number.length > 34) {
                    errorId = 'iban_bad_length';
                }
                //check invalid characters
                else if (!/[A-Z]{2}[0-9A-Z]+/.test(number)) {
                    errorId = 'iban_bad_chars';
                }
                else {
                    var rearranged = number.substring(4) + number.substring(0, 4);
                    var converted = rearranged.replace(/[A-Z]/g, function (c) {
                        return c.charCodeAt(0) - 55;
                    });
                    if (_mod97(converted) === 1) {
                        ddNumberErrorId.style.display = 'none';
                        ddElement.className = '';
                        if (document.getElementById('ddIBANValidationSuccess')) {
                            document.getElementById('ddIBANValidationSuccess').className = 'success';
                        }

                        return "OK";
                    }
                    else {
                        errorId = 'iban_checksum_fail';
                    }
                }
            } else {
                errorId = 'iban_empty';
            }

            if (errorId) {
                ddNumberErrorId.style.display = 'inline';
                document.getElementById('dd_' + errorId).style.display = 'inline';
                ddElement.className = 'error';
                if(document.getElementById('ddIBANValidationSuccess')) {
                    document.getElementById('ddIBANValidationSuccess').className = '';
                }
            }

            return errorId;
        }

        return {
            validateDirectDebit: _validateDirectDebit,
            validateIBAN: _validateIBAN
        };
    }();

    return PhxCheckout;

}(PhxCheckout || {}));
